import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import BidReviewsSummaryModal from './BidReviewsSummaryModal';

export default class BidReviewsSummaryComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };

        this.onShowModal = this.onShowModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
    }

    onShowModal() {
        this.setState({showModal: true});
    }

    onCloseModal() {
        this.setState({showModal: false});
    }

    render() {
        return (
            <div>
                <div className="pull-right">
                    <button className="btn btn-primary" onClick={this.onShowModal}>
                        <i className="fa fa-fw fa-search"></i> {window.__js_bid_reviews.reviewers_opinions}
                    </button>
                </div>
                <BidReviewsSummaryModal
                    competitionId={this.props.competitionId}
                    show={this.state.showModal}
                    onClose={this.onCloseModal}
                />
            </div>
        );
    }
}

const element = document.getElementById('bid-reviews-summary-component');

if (element) {
    const competitionId = element.getAttribute('data-competition-id');

    ReactDOM.render(
        <BidReviewsSummaryComponent
            competitionId={competitionId}
        />,
        element
    );
}